// Module
var code = `<header class="top-bar breadcrumb__info">

  <img class="top-bar__logo" src="/img/nextbank-logo.svg"/>
  <div class="breadcrumb__command-section" ng-if="\$ctrl.approvedCommand">
    <div>
      <div class="cmd-label">Action approved:</div>
      <div class="cmd-name">{{\$ctrl.approvedCommand.displayName}}</div>
    </div>
    <i ng-if="\$ctrl.approvedCommand.prints.length > 0"
       ng-click="\$ctrl.approvedCommandPrint(\$ctrl.approvedCommand)"
       class="breadcrumb__home icon-print" title="Print"></i>
  </div>

  <div class="breadcrumb__home-section" ng-if="!\$ctrl.userOnHomeBranch" ng-click="\$ctrl.switchContextToHomeBranch()">
    <i class="breadcrumb__home icon-home"
       title="Switch back to user's home branch"
    ></i>
  </div>
  <div class="top-bar__info-section">
    <selectize
      class="breadcrumb__branch-select"
      config="\$ctrl.selectizeConfig"
      options="\$ctrl.contextBranches"
      ng-model="\$ctrl.branchContextId"
      ng-change="\$ctrl.onBranchContextUpdate()">
    </selectize>
  </div>
  <div class="top-bar__info-section">
    <div class="breadcrumb__info-image breadcrumb__user-image top-bar__user-image"></div>
    <div class="top-bar__info-container">
      <p class="breadcrumb__info">{{\$ctrl.user.fullName}}</p>
      <div class="breadcrumb__info-footer">
        <a class="breadcrumb__info-details top-bar__info-details"
           ng-href="#!/admin/organization/users/{{\$ctrl.user.branchId}}/user/{{\$ctrl.user.id}}">
          Settings
        </a>
        <span class="breadcrumb__info-details--more-container">
          <a tabindex="-1" class="breadcrumb__info-details top-bar__info-details breadcrumb__info-details--more"
             role="button"
             data-toggle="popover" data-trigger="focus" data-placement="bottom">
            Info
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="breadcrumb__logout-section" ng-click="\$ctrl.refresh()">
    <i class="breadcrumb__logout top-bar__refresh-icon"></i>
  </div>
  <div class="breadcrumb__logout-section" ng-click="\$ctrl.logout()">
    <i class="breadcrumb__logout icon-off"></i>
  </div>
</header>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/top-bar/top-bar.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;